import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import app from './appReducer'
import auth from './authReducer'
import getCare from './getCareReducer'
import appointments from './appointmentsReducer'
import signup from './signupReducer'
import profile from './profileReducer'
import account from './accountReducer'
import payment from './paymentReducer'
import videoCall from './videoCallReducer'
import ds from './dosespotReducer'
import medicalInfo from './medicalInfoReducer'
import notifications from './notificationReducer'
import providers from './providersReducer'
import locale from './localeReducer'
import nhMember from './nhMemberReducer'

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    app,
    auth,
    getCare,
    appointments,
    signup,
    profile,
    account,
    payment,
    videoCall,
    ds,
    medicalInfo,
    notifications,
    providers,
    locale,
    nhMember,
  })

export default rootReducer
